import * as fromReducer from './team.reducer';
import {FeatureKeys} from '../app.reducer';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import { ISRDetail, ITeam } from '@signal/asp-data-commons';

/* Selectors from the entity adapter */
export const {
  selectAll,
  selectTotal
} = fromReducer.adapter.getSelectors();

/* To select the teams feature in the app state */
export const selectTeamsFeature = createFeatureSelector<fromReducer.TeamState>(FeatureKeys.TEAMS);

/* To select the teams loading in the teams state */
export const selectTeamsLoading = createSelector(
  selectTeamsFeature,
  (state: fromReducer.TeamState) => state.loading
);

/* To select the teams loaded in the teams state */
export const selectTeamsLoaded = createSelector(
  selectTeamsFeature,
  (state: fromReducer.TeamState) => state.loaded
);

export const selectCanTeamsBeReloaded = createSelector(
  selectTeamsFeature,
  (state: fromReducer.TeamState) => !(state.loaded && state.loading && state.error)
);

/* To select the teams data in the teams state */
export const selectTeams = createSelector(
  selectTeamsFeature,
  selectAll
);

/* To select the teams count in the teams state */
export const selectTeamsCount = createSelector(
  selectTeamsFeature,
  selectTotal
);

/* To select teams for schedule rotation */
export const selectTeamsForSchedule = createSelector(
  selectTeams,
  (employees: ITeam[]) => employees.map(x => { return <ISRDetail>{id: x.id, name: x.name}})
)

export const selectTeamColors = createSelector(
  selectTeams,
  (teams: ITeam[]) => teams.map(x => x.teamColor)
)

/* to update employee details */
export const selectUpdateEmployeeDetails = createSelector(
  selectTeamsFeature,
  (state: fromReducer.TeamState) => state.empDetailsUpadated
);

export const selectUpdateEmployeeTeam = createSelector(
  selectTeamsFeature,
  (state: fromReducer.TeamState) => state.loading
);

export const selectTxmTeam = createSelector(
  selectTeams,
  (teams: ITeam[]) => teams.filter(x=> x.name === 'TXM')
)
export const selectNonTxmTeams = createSelector(
  selectTeams,
  (teams: ITeam[]) => teams.filter(x=> x.name !== 'TXM')
)

export const selectNonTxmTeamsCount = createSelector(
  selectNonTxmTeams,
  (teams: ITeam[]) => teams.length
)


